import React, { useState, useEffect, use } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

import Login from './pages/Login';
import Home from './pages/Home';

function AppContent() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [username, setUsername] = useState('');
  const [role, setRole] = useState('');
  const navigate = useNavigate();

  // =============================
  // RESTORE SESSION PER TAB
  // =============================
  useEffect(() => {
    const tabId = sessionStorage.getItem("activeTab");
    if (!tabId) return;

    const savedUser = sessionStorage.getItem(`username_${tabId}`);
    const savedRole = sessionStorage.getItem(`role_${tabId}`);

    if (savedUser && savedRole) {
      setIsLoggedIn(true);
      setUsername(savedUser);
      setRole(savedRole);
    }
  }, []);

  // =============================
  // LOGIN HANDLER
  // =============================
  const handleLogin = (user, userRole) => {
    setIsLoggedIn(true);
    setUsername(user);
    setRole(userRole);
    console.log("User Roal: ", userRole);

    navigate('/live-status'); // LIVE STATUS - CHANGED TO COMPANY
  };

  // =============================
  // LOGOUT HANDLER
  // =============================
  const handleLogout = () => {
    const tabId = sessionStorage.getItem("activeTab");

    if (tabId) {
      sessionStorage.removeItem(`token_${tabId}`);
      sessionStorage.removeItem(`role_${tabId}`);
      sessionStorage.removeItem(`username_${tabId}`);
      sessionStorage.removeItem("activeTab");
    }

    setIsLoggedIn(false);
    setUsername('');
    setRole('');

    navigate('/login');
  };

  return (
    <div className="App">
      {!isLoggedIn ? (
        <Routes>
          <Route path="/login" element={<Login onLogin={handleLogin} />} />
          <Route path="*" element={<Login onLogin={handleLogin} />} />
        </Routes>
      ) : (
        <Routes>
          <Route path="/" element={<Home username={username} role={role} onLogout={handleLogout} />} />
          {/* LIVE STATUS - COMMENTED OUT */}
          <Route path="/live-status" element={<Home username={username} role={role} onLogout={handleLogout} />} />
         
          <Route path="/company" element={<Home username={username} role={role} onLogout={handleLogout} />} />
          <Route path="/total-employees" element={<Home username={username} role={role} onLogout={handleLogout} />} />
          <Route path="/add-employee" element={<Home username={username} role={role} onLogout={handleLogout} />} />
          <Route path="/person-logs/:personId" element={<Home username={username} role={role} onLogout={handleLogout} />} />
        </Routes>
      )}
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}
